import { STAGES } from "../../../utils/stageManagement";

export const navItems = [
  {
    id: "general",
    name: "General Information",
    shortName: "General Info",
    icon: "fi fi-rr-info",
    stage: STAGES.GENERAL,
    description: "Basic package details and destination information",
    essential: true,
  },
  {
    id: "itinerary",
    name: "Package Itinerary",
    shortName: "Itinerary",
    icon: "fi fi-rr-map",
    stage: STAGES.ITINERARY,
    description: "Day-wise plan, meals, attractions, and travel details",
    essential: true,
  },
  {
    id: "stay",
    name: "Stay Information",
    shortName: "Stay",
    icon: "fi fi-rr-home",
    stage: STAGES.STAY,
    description: "Hotels, room categories, and accommodation options",
    essential: true,
  },
  {
    id: "inclusion",
    name: "Inclusion and Exclusion",
    shortName: "Inclusion & Exclusion",
    icon: "fi fi-rr-list-check",
    stage: STAGES.INCLUSION,
    description: "What's included, excluded, and things to carry",
    essential: true,
  },
  {
    id: "pricing",
    name: "Pricing",
    shortName: "Pricing",
    icon: "fi fi-rr-money-bill-wave",
    stage: STAGES.PRICING,
    description: "Rates, discounts, payment terms, and stop sales",
    essential: true,
  },
  {
    id: "additional",
    name: "Additional Information",
    shortName: "Additional Info",
    icon: "fi fi-rr-document",
    stage: STAGES.ADDITIONAL,
    description: "Extra notes and information for travellers",
    essential: false,
    defaultCollapsed: true,
  },
  {
    id: "terms",
    name: "Terms & Conditions",
    shortName: "Terms",
    icon: "fi fi-rr-memo-circle-check",
    stage: STAGES.TERMS,
    description: "Booking rules, policies, and legal terms",
    essential: false,
    defaultCollapsed: true,
  },
  {
    id: "cancellation",
    name: "Cancellation Policy",
    shortName: "Cancellation",
    icon: "fi fi-rr-cross-circle",
    stage: STAGES.CANCELLATION,
    description: "Refund rules and cancellation timelines",
    essential: false,
    defaultCollapsed: true,
  },
  {
    id: "faq",
    name: "FAQs",
    shortName: "FAQ",
    icon: "fi fi-rr-interrogation",
    stage: STAGES.FAQ,
    description: "Common questions and answers about the package",
    essential: false,
  },
];

export const isSectionCompleted = (completedStage, itemStage) => {
  const stage = Number(completedStage) || 0;
  return stage > itemStage || (stage === STAGES.FAQ && itemStage === STAGES.FAQ);
};

export const getNextSectionId = (currentSectionId) => {
  const index = navItems.findIndex((item) => item.id === currentSectionId);
  if (index === -1 || index >= navItems.length - 1) return null;
  return navItems[index + 1].id;
};

export const isOptionalPackageSection = (sectionId) => {
  const item = navItems.find((nav) => nav.id === sectionId);
  return Boolean(item && !item.essential);
};

export const getCompletedSectionsCount = (completedStage) => {
  const stage = Number(completedStage) || 0;
  if (stage >= STAGES.FAQ) return navItems.length;
  return navItems.filter((item) => stage > item.stage).length;
};

export const getCompletionPercent = (completedStage) => {
  const completed = getCompletedSectionsCount(completedStage);
  return Math.round((completed / navItems.length) * 100);
};

export const getMissingSections = (completedStage) => {
  const stage = Number(completedStage) || 0;
  if (stage >= STAGES.FAQ) return [];
  return navItems
    .filter((item) => !isSectionCompleted(stage, item.stage))
    .map((item) => item.name);
};
